import { MutableRefObject, useRef, useState } from "react"
import { BuildHexMap, HexMapBuilderParams } from "../../../Data/HexMap/HexMapBuilder"
import { HexMap } from "../../../Data/HexMap/HexMap"
import { HexMapModifier } from "../../../Data/HexMap/HexMapModifier"
import { All } from "../../../Util/Constants/Quantities"
import { Note } from "../../../Data/HexMap/Note"
import { HxMapGroup } from "../../../Comps/HxMap/HxMapGroup"
import { TransformTranslate } from "../../../Util/Transform/Transform"
import { IntervalButtons } from "../../../Comps/NoteButtons/IntervalButtons"
import { OutlineBox } from "../../../Comps/OutlineBox/OutlineBox"
import { ExerciseMessage } from "../Utils/Message/ExerciseMessage"
import { RelativeKeySelector } from "../../../Util/TonicSelector/RelativeKeySelector"

export function HexCompassExercise(){
    const realtiveValues:number[] = [11,8,5,2,3,0,9,6,10,7,4,1]
    const selector:MutableRefObject<RelativeKeySelector> = useRef(new RelativeKeySelector(9))
    const tonic:number = 11
    const radius:number = 70
    const [selectedKeyIndex, setSelectedKeyIndex] = useState(selector.current.getRandomPosition(-1))
    const initializeMap = (mod:HexMapModifier) => {
        mod.notes_setVisible([All], true)
        mod.keys_setOpen([All], false)
        mod.draft.keys.flat()[0].predefinedLabel = '7th'
        mod.draft.keys.flat()[1].predefinedLabel = 'b6th'
        mod.draft.keys.flat()[2].predefinedLabel = '4th'
        mod.draft.keys.flat()[3].predefinedLabel = '2nd'
        mod.draft.keys.flat()[4].predefinedLabel = 'b3rd'
        mod.draft.keys.flat()[5].predefinedLabel = ''
        mod.draft.keys.flat()[6].predefinedLabel = '6th'
        mod.draft.keys.flat()[7].predefinedLabel = 'b5th'
        mod.draft.keys.flat()[8].predefinedLabel = 'b7th'
        mod.draft.keys.flat()[9].predefinedLabel = '5th'
        mod.draft.keys.flat()[10].predefinedLabel = '3rd'
        mod.draft.keys.flat()[11].predefinedLabel = 'b2nd'
        mod.keys_setSelectedState([All], Note.SelectedState_Default)
        mod.keys_setHilited([selectedKeyIndex])
        mod.keys_setSelected([5])
        mod.keys_setDefined([All], false)
        if(definedKey.current !== null){
            mod.keys_setDefined([definedKey.current], true)
        }
    }
    const definedKey:MutableRefObject<number|null> = useRef(null)
    const getHexMap = () => {
        const params:HexMapBuilderParams = {
            rows:3, columns:4, tonic:tonic, radius:radius
        }
        const map:HexMap = BuildHexMap(params)
        const mod:HexMapModifier = new HexMapModifier(map)
        initializeMap(mod)
        return map
    }
    const defaultMsg:string = 'Define the realtive key highlited below.'
    const [message, setMessage] = useState<[string, boolean|null]>([defaultMsg, null])
    const next = () => {
        definedKey.current = null
        setSelectedKeyIndex(selector.current.getRandomPosition())
        setMessage([defaultMsg, null])
    }
    const onCorrect = () => {
        definedKey.current = selectedKeyIndex
        setMessage(['Correct!', true])
        setTimeout(next, 1500)
    }
    const onIncorrect = () => {
        setMessage(['Incorrect, try again.', false])
    }
    const onNoteButtonSelect = (interval:number) => {
        const relVal:number = realtiveValues[selectedKeyIndex]
        if(interval === relVal){
            onCorrect()
            return
        }
        onIncorrect()
    }
    return(
        <div className={'hex-builder'}>
            <OutlineBox width={700}>
                <ExerciseMessage message={message[0]} key={Date.now()} answerStatus={message[1]}/>
                <svg width={620} height={400}>
                    <g transform={TransformTranslate(310,180)}>
                        <HxMapGroup hexMap={getHexMap()}/>
                    </g>
                </svg>
                <div>
                    <IntervalButtons onClick={onNoteButtonSelect}/>
                </div>
            </OutlineBox>
        </div>
    )
}